import { TagKindSchema, TagSchema } from "@redotech/redo-common-model/tag";
import * as z from "zod";

export const getTeamTags = {
  name: "getTeamTags" as const,
  input: z.object({ kind: TagKindSchema }),
  output: z.object({ tags: z.array(TagSchema) }),
};
